import React from "react";
const Career = () => {
  return (
    <div className="container py-5 mt-5">
      {/* Header Section */}
      <div className="text-center mb-5">
        <h1 class="text-muted">.</h1>
        <h1 className="fw-bold text-primary ">Join Our Team at Technociv Technologies</h1>
        <p style={{ color: 'black' }}>
          At Technociv Technologies, we believe that our people are our greatest asset. We are dedicated to fostering a collaborative and innovative work environment where every team member can thrive. If you're passionate about engineering and technology and want to be part of a dynamic team that's committed to delivering high-quality solutions, we invite you to explore our career opportunities.
        </p>
      </div>
      {/* Why Work With Us Section */}
      <section className="mb-5">
        <h2 className="text-primary">Why Work With Us?</h2>
        <ul className="list-unstyled">
          <li className="mb-2"><strong>Innovative Environment:</strong> Be part of a team that values creativity and innovation, pushing the boundaries of technology in various engineering disciplines.</li>
          <li className="mb-2"><strong>Professional Growth:</strong> We are committed to your development, offering training programs and opportunities for career advancement.</li>
          <li className="mb-2"><strong>Diverse Team:</strong> Our team comprises professionals from various engineering backgrounds, providing a rich environment for collaboration and learning.</li>
          <li className="mb-2"><strong>Impactful Work:</strong> Contribute to projects that make a difference, from advanced automation solutions to high-precision testing instruments.</li>
        </ul>
      </section>
      {/* Current Openings Section */}
      <section className="mb-5">
        <h2 className="text-primary">Current Openings</h2>
        <div className="mb-3">
          <h5>1. Engineering Positions:</h5>
          <ul>
            <li>Electrical and Electronics Engineers</li>
            <li>Embedded System Engineer</li>
            <li>Software Developers (NI LabVIEW, Automation)</li>
            <li>Test Engineers</li>
            <li>PLC Programmer</li>
          </ul>
        </div>
        <div className="mb-3">
          <h5>2. Project Management:</h5>
          <ul>
            <li>Project Managers with experience in engineering and technology sectors.</li>
          </ul>
        </div>
        <div className="mb-3">
          <h5>3. Sales and Marketing:</h5>
          <ul>
            <li>Sales Engineers with a background in technical sales.</li>
            <li>Marketing Specialists to promote our innovative solutions.</li>
          </ul>
        </div>
        <div>
          <h5>4. Internships:</h5>
          <ul>
            <li>Engineering internships for students eager to gain hands-on experience in a professional environment.</li>
          </ul>
        </div>
      </section>
      {/* How to Apply Section */}
      <section className="mb-5">
        <h2 className="text-primary">How to Apply</h2>
        <p style={{ color: 'black' }}>
          If you are interested in joining our team, please send your resume and a cover letter outlining your qualifications and interests to <a href="mailto:info@technociv.com" class="text-primary">hr@technociv.com</a>. We review applications on a rolling basis and will reach out to you if your profile matches our needs.
        </p>
      </section>
      {/* Equal Opportunity Section */}
      <section className="mb-5">
        <h2 className="text-primary">Technociv Technologies is an Equal Opportunity Employer</h2>
        <p style={{ color: 'black' }}>
          We celebrate diversity and are committed to creating an inclusive environment for all employees. We encourage applications from individuals of all backgrounds and experiences.
        </p>
      </section>
      {/* Connect with Us Section */}
      <section>
        <h2 className="text-primary">Connect with Us</h2>
        <p style={{ color: 'black' }}>
          Stay updated on our latest job openings and company news by following us on <a href="#">LinkedIn</a>, <a href="#">Instagram</a>, <a href="#">Facebook</a>, and <a href="#">Google</a>. We look forward to welcoming you to the Technociv family!
        </p>
      </section>
    </div>
  );
};

export default Career;
